export const isFloat = (n) => Number(n) === n && n % 1 !== 0
